var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0481 12C10.7021 13.1144 6.5 16.3533 6.5 22.3715C6.5 28.1659 8.77273 29 16.5 29C24.2273 29 26.5 28.2336 26.5 22.3715C26.5 16.5173 22.5238 13.293 19.2273 12.0959",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.298 12L9.9284 6.7771C9.57562 5.99955 10.2967 5.16605 11.1169 5.40332L13.0919 5.97466C13.4622 6.08178 13.8611 5.96653 14.1172 5.67841L15.7506 3.84084C16.1484 3.39332 16.8477 3.39332 17.2455 3.84084L18.8478 5.64352C19.1197 5.94937 19.5505 6.05872 19.9353 5.91956L21.1102 5.4947C21.8925 5.21183 22.658 5.95208 22.4016 6.7434L20.698 12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1364 17.2C17.7727 16.4 17.2036 16 16.3182 16C15.4327 16 14.8636 16.8 14.8636 17.6C14.8636 18.8 15.9545 19.3333 16.6818 19.6C17.4091 19.8667 18.5 20.8 18.5 22C18.5 23.2 17.7727 24 16.6818 24C15.5909 24 14.5 23.2 14.5 22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15L16.5 16",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24L16.5 25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.f68896a6da063e8600aa61abc009e974.svg";
export { ForwardRef as ReactComponent };